import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'slate_design_system-ui_modal_show-view';

/**
 * Emitted when a Slate modal is shown to the user
 */
export function trackSlateDesignSystemUiModalShowView(
  modalId: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { modalId },
  });
}
